import merge from 'lodash/merge.js';

import BaseRubric from '@/store/modules/base/BaseRubric.js';

export default merge(BaseRubric, { autoImport: false });
